/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfPassengerDataFileFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfPassengerDataFile, type AgGridClientQuery, type PagingResponseOfPassengerDataFile, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Dashboard/GetByFile
 */
export interface GetByFileRequestBuilder extends BaseRequestBuilder<GetByFileRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfPassengerDataFile>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetByFileRequestBuilderPostQueryParameters> | undefined) : Promise<PagingResponseOfPassengerDataFile | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<GetByFileRequestBuilderPostQueryParameters> | undefined) : RequestInformation;
}
export interface GetByFileRequestBuilderPostQueryParameters {
    showOnlyAssignedToMe?: boolean;
    showOnlyDeparturesWithinWeek?: boolean;
    showOnlyErrors?: boolean;
    showPastDepartures?: boolean;
}
/**
 * Uri template for the request builder.
 */
export const GetByFileRequestBuilderUriTemplate = "{+baseurl}/Dashboard/GetByFile?showOnlyAssignedToMe={showOnlyAssignedToMe}&showOnlyDeparturesWithinWeek={showOnlyDeparturesWithinWeek}&showOnlyErrors={showOnlyErrors}&showPastDepartures={showPastDepartures}";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetByFileRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetByFileRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfPassengerDataFileFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
